// src/Components/ImagePage.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import '../style/ImagePage.css'; // CSS dosyasını ekle
import anlatim2 from '../assets/anlatim2.jpeg';
import anlatim3 from '../assets/anlatim3.jpeg';
import anlatimVideo from '../assets/video/anlatim.mp4';

export const ImagePage = () => {
  const location = useLocation();
  const image = location.state ? location.state.image : null;

  if (!image) {
    return <h2>Image not found</h2>;
  }

  // ID'si 15 olan özel durum için
  if (image.id === 15) {
    return (
      <div className="image-page">
        <h1>{image.alt}</h1>
        <p>{image.legend}</p>
        <div className="media-grid">
          <img src={anlatim2} alt="İtalya sunumu 1" />
          <img src={anlatim3} alt="İtalya sunumu 2" />
          <video controls>
            <source src={anlatimVideo} type="video/mp4" />
            Tarayıcınız video etiketini desteklemiyor.
          </video>
        </div>
      </div>
    );
  }

  return (
    <div className="image-page">
      <h1>{image.alt}</h1>
      <img src={image.src} alt={image.alt} />
      <p>{image.legend}</p>
    </div>
  );
};
